import React from "react";
import { Select, Form } from "antd";
import { useQueryClient } from "react-query";

export default function SelectTheme() {
  const { topics } = useDicts();

  return (
    <Form.Item name="topicId" label="Тема" rules={[{ required: true }]}>
      <Select
        showSearch
        allowClear
        optionFilterProp="children"
        placeholder="Выберите тему"
      >
        {topics.map((item) => (
          <Select.Option key={item.id} value={item.id} title={item.tooltips || 'подробного описания нет'}>
            {item.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

function useDicts() {
  const queryClient = useQueryClient();
  const topics = queryClient.getQueryData<Models.Dict[]>("topics");

  return { topics };
}
